import {
  COURSE_TYPE_ALL_TYPES,
  CourseType,
} from '@openeducation/oe-it-shared-types';
import React, { FC, memo, useMemo } from 'react';
import { View } from 'react-native';

import {
  DropdownInputType,
  DropdownItemType,
  SelectDropdownInput,
} from '../select-dropdown-input';

export type CourseSelectorProps = {
  data: DropdownItemType[];
  value: CourseType | null;
  onChange: (courseType: CourseType | null) => void;
};

const CourseSelector: FC<CourseSelectorProps> = ({ value, onChange, data }) => {
  const defaultValue = useMemo(
    () =>
      data.find((item) =>
        value === null
          ? item.value === COURSE_TYPE_ALL_TYPES
          : item.value === value
      ),
    [data, value]
  );

  const onSelect = ({ key }: DropdownItemType) => {
    onChange(key === COURSE_TYPE_ALL_TYPES ? null : (key as CourseType));
  };

  return (
    <View>
      <SelectDropdownInput
        defaultValue={defaultValue}
        onSelect={onSelect}
        data={data}
        width={170}
        type={DropdownInputType.MINIMAL}
      />
    </View>
  );
};

export default memo(CourseSelector);
